export const NestedFormMaxNumber = (controller) => {
  Object.assign(controller, {
    // xxxx_attributes_[number]_idの形式のIDを持つ要素から最大の番号を取得します。
    maxNumberFromId: (elements) => {
      let max = -1;

      elements.forEach((el) => {
        const m = el.id.match(/_attributes_(\d+)_id/);
        if (m && m[1] != null) {
          const idx = parseInt(m[1], 10);
          if (!isNaN(idx) && idx > max) {
            max = idx;
          }
        }
      });

      // 見つからなかった場合は-1を返す
      return max;
    },
  });
};
